import { useState } from "react";
import "./PerKmToggle.css"; // Create this CSS file for styling

function PerKmToggle({ value, onChange }) {
    const [loading, setLoading] = useState(false);

    const handleToggle = async () => {
        if (loading) return;

        const newValue = !value;

        try {
            setLoading(true);

            // call parent handler (API call)
            await onChange(newValue);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className={`custom-toggle ${value ? "active" : ""} ${loading ? "disabled" : ""}`}
            onClick={handleToggle}
        >
            <div className="toggle-thumb" />
        </div>
    );
}

export default PerKmToggle;